<template>
  <div class="card-delay-help">
    <div class="help-title">付费延期说明</div>
    <ul class="help-content">
      <li>1、卖座券过期后，额外延长使用时间需付费</li>
      <li>2、已过期超过180天的券不予延期</li>
      <li>3、收费标准：根据过期时长收费，{{price | price2}}{{isBind ? '元/30天' : '元/30天'}}/券，不足30天按30天计算</li>
      <li>4、付费后有效期以付费时间为起点延后30天{{isBind ? '' : '，并自动绑定到当前账户'}}</li>
      <li>5、每张券只能延期1次</li>
      <li>6、每个账户每天延期不超过6张券</li>
    </ul>
  </div>
</template>

<script>
  import op from 'object-path'

  export default {
    name: 'card-delay-help',
    props: ['cardData', 'price'],
    data() {
      return {
      }
    },
    computed: {
      isBind() {
        return op(this.cardData).get('0.isBind')
      }
    },
    mounted() {
    },
  }
</script>

<style lang="less" scoped>
  @import '../../stylesheet/variable.less';
  .card-delay-help {
    background-color: @white;
    .help-title {
      height: 49px;
      display: flex;
      padding-left: 15px;
      align-items: center;
      font-size: 15px;
      color: @darkGrey;
      background-color: @white;
      position: relative;
      &:after {
        .setBottomLine()
      }
    }
    .help-content {
      margin: 0;
      font-size: 13px;
      line-height: 22px;
      color: @steelGrey;
      padding: 12px 15px;
      list-style: none;
      background-color: @white;
    }
  }
</style>

